import { useEffect } from 'react';

import MapToolMode from "lib/enums/maptoolmode";

import { Popup } from 'lib/classes/popup';
import { getToolEnabled } from 'lib/utilities/toolmodes';
import { assetURL } from 'lib/utilities/asset';
import { getLocaleString } from 'lib/localization/vendor';

import 'styles/css/DrawTool.scss';

const DrawPortalPopup = new Popup({
	title: () => getLocaleString('drawing'),
	style: {maxWidth: 600, minWidth: 300},
	distinct: true,
	render: function() {
		const mapConfig:any = this.get('map-config');
		const drawSiteEnabled:boolean = getToolEnabled(MapToolMode.Draw, mapConfig);
		const annotateEnabled:boolean = getToolEnabled(MapToolMode.Annotation, mapConfig);
		
		const clickSite = () => {
			_ui.setToolMode(MapToolMode.Draw);
			_ui.closePopupOf(this);
		}
		const clickAnnotate = () => {
			_ui.setToolMode(MapToolMode.Annotation);
			_ui.closePopupOf(this);
		}
		
		const drawSiteOption = () => (
			<div className='draw-portal-option' data-tip={getLocaleString('drawsitetip')} data-delay-show="400">
				<button onClick={clickSite}>
					<img src={assetURL('assets/images/draw.png')} width='30' />
					
					<p>{getLocaleString('drawsite')}</p>
				</button>
			</div>
		);
		const drawAnnotateOption = () => (
			<div className='draw-portal-option' data-tip={getLocaleString('annotatetip')} data-delay-show="400">
				<button onClick={clickAnnotate}>
					<img src={assetURL('assets/images/annotation.png')} width='30' />
					
					<p>{getLocaleString('annotatemap')}</p>
				</button>
			</div>
		);
		
		return (
			<div className='draw-portal'>
				<p>
					<b>{getLocaleString('drawportalhead')}</b>
				</p>
				
				{drawSiteEnabled && drawSiteOption()}
				{annotateEnabled && drawAnnotateOption()}
			</div>
		)
	}
});

export default DrawPortalPopup;